import { createSlice, createAsyncThunk } from "@reduxjs/toolkit"
import * as api from "../api"

export const getEndorsements = createAsyncThunk("get-endorsements", async () => {
    const response = await api.getEndorsements()
    return response
})

export const getEndorsement = createAsyncThunk("get-endorsement", async (id) => {
    const response = await api.getEndorsement(id)
    return response
})

export const createEndorsement = createAsyncThunk("create-endorsement", async (payload) => {
    const response = await api.addEndorsement(payload)
    return response
})

export const editEndorsement = createAsyncThunk("edit-endorsement", async (payload) => {
    const response = await api.editEndorsement(payload)
    return response
})

export const reorderEndorsementsList = createAsyncThunk("reorder-endorsements", async (payload) => {
    const response = await api.reorderEndorsements(payload)
    return response
})

export const clearEndorsement = createAsyncThunk("clear-endorsement", async () => {
    return
})

export const deleteEndorsement = createAsyncThunk("delete-endorsement", async (id) => {
    const response = await api.deleteEndorsement(id)
    if (response.succeeded) {
        return id
    } else return null
})

export const addEndorsementFile = createAsyncThunk("add-endorsement-file", async (payload) => {
    const response = await api.addEndorsementFile(payload)
    return response
})

export const addEndorsement = createAsyncThunk("add-endorsement", async (payload) => {
    const response = await api.addEndorsement(payload)
    return response
})

export const deleteEndorsementFile = createAsyncThunk("delete-endorsement-file", async (id) => {
    const response = await api.deleteEndorsementFile(id)
    return response
})

const endorsementSlice = createSlice({
    name: "endorsement",
    initialState: {
        data: [],
        endorsement: {},
        fetchStatus: "",
        action: ""
    },
    reducers: {
        updateEndorsement(state, action) {
            const { field, value } = action.payload
            state.endorsement = { ...state.endorsement, [field]: value }
        },
        reorderEndorsements(state, action) {
            const { dragIndex, hoverIndex } = action.payload
            const clonedData = [...state.data]

            const movedEndorsement = clonedData[dragIndex]
            clonedData.splice(dragIndex, 1)
            clonedData.splice(hoverIndex, 0, movedEndorsement)
            state.data = clonedData
        }
    },
    extraReducers: (builder) => {
        builder
            .addCase(getEndorsements.fulfilled, (state, action) => {
                state.data = action.payload
                state.fetchStatus = "success"
                state.action = "getEndorsements"
            })
            .addCase(getEndorsements.pending, (state) => {
                state.fetchStatus = "loading"
                state.action = "getEndorsements"
            })
            .addCase(getEndorsements.rejected, (state) => {
                state.fetchStatus = "error"
                state.action = "getEndorsements"
            })

            .addCase(getEndorsement.fulfilled, (state, action) => {
                state.endorsement = action.payload
                state.fetchStatus = "success"
                state.action = "getEndorsement"
            })
            .addCase(getEndorsement.pending, (state) => {
                state.fetchStatus = "loading"
                state.action = "getEndorsement"
            })
            .addCase(getEndorsement.rejected, (state) => {
                state.fetchStatus = "error"
                state.action = "getEndorsement"
            })
            .addCase(reorderEndorsementsList.fulfilled, (state, action) => {
                state.fetchStatus = "success"
                state.action = "reorderEndorsementsList"
            })
            .addCase(reorderEndorsementsList.pending, (state) => {
                state.fetchStatus = "loading"
                state.action = "reorderEndorsementsList"
            })
            .addCase(reorderEndorsementsList.rejected, (state) => {
                state.fetchStatus = "error"
                state.action = "reorderEndorsementsList"
            })
            .addCase(createEndorsement.fulfilled, (state, action) => {
                state.fetchStatus = "success"
                state.action = "createEndorsement"
            })
            .addCase(createEndorsement.pending, (state) => {
                state.fetchStatus = "loading"
                state.action = "createEndorsement"
            })
            .addCase(createEndorsement.rejected, (state) => {
                state.fetchStatus = "error"
                state.action = "createEndorsement"
            })
            .addCase(editEndorsement.fulfilled, (state, action) => {
                state.fetchStatus = "success"
                state.action = "editEndorsement"
            })
            .addCase(editEndorsement.pending, (state) => {
                state.fetchStatus = "loading"
                state.action = "editEndorsement"
            })
            .addCase(editEndorsement.rejected, (state) => {
                state.fetchStatus = "error"
                state.action = "editEndorsement"
            })

            .addCase(clearEndorsement.fulfilled, (state, action) => {
                state.endorsement = {}
                state.action = "clearEndorsement"
            })
            .addCase(clearEndorsement.pending, (state) => {
                state.action = "clearEndorsement"
            })
            .addCase(clearEndorsement.rejected, (state) => {
                state.action = "clearEndorsement"
            })

            .addCase(deleteEndorsement.fulfilled, (state, action) => {
                if (!!action.payload) {
                    const updatedData = state.data.filter((row) => row.id !== action.payload)
                    state.data = [...updatedData]
                }
                state.fetchStatus = "success"
            })
            .addCase(deleteEndorsement.pending, (state) => {
                state.fetchStatus = "loading"
            })
            .addCase(deleteEndorsement.rejected, (state) => {
                state.fetchStatus = "error"
            })
            .addCase(addEndorsementFile.fulfilled, (state, action) => {
                state.action = "addEndorsementFile"
                state.fetchStatus = "success"
            })
            .addCase(addEndorsementFile.pending, (state) => {
                state.action = "addEndorsementFile"
                state.fetchStatus = "loading"
            })
            .addCase(addEndorsementFile.rejected, (state) => {
                state.action = "addEndorsementFile"
                state.fetchStatus = "error"
            })
            .addCase(addEndorsement.fulfilled, (state, action) => {
                state.action = "addEndorsement"
                state.fetchStatus = "success"
            })
            .addCase(addEndorsement.pending, (state) => {
                state.action = "addEndorsement"
                state.fetchStatus = "loading"
            })
            .addCase(addEndorsement.rejected, (state) => {
                state.action = "addEndorsement"
                state.fetchStatus = "error"
            })
            .addCase(deleteEndorsementFile.fulfilled, (state, action) => {
                state.action = "deleteEndorsementFile"
                state.fetchStatus = "success"
            })
            .addCase(deleteEndorsementFile.pending, (state) => {
                state.action = "deleteEndorsementFile"
                state.fetchStatus = "loading"
            })
            .addCase(deleteEndorsementFile.rejected, (state) => {
                state.action = "deleteEndorsementFile"
                state.fetchStatus = "error"
            })
    }
})

export default endorsementSlice

export const { name, actions, reducers } = endorsementSlice
